import { render, staticRenderFns } from "./GiftModal.vue?vue&type=template&id=e9915dae&scoped=true&"
import script from "./GiftModal.vue?vue&type=script&lang=js&"
export * from "./GiftModal.vue?vue&type=script&lang=js&"
import style0 from "./GiftModal.vue?vue&type=style&index=0&id=e9915dae&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9915dae",
  null
  
)

export default component.exports